$(document).ready(function() {
	
	if(!document.getElementById('download_list')) return false;

	var downloadList = document.getElementById("download_list");
	var downloadForm = document.getElementById("download_form");
	var downloadPageButton = $(downloadList).find(".pagination");	
	var downloadResult = $(downloadList).find(".result");
	var downloadResultNow = downloadResult.find(".current-page");
	var downloadPageView = 5;
	var downloadPageViewIndex = 0;
	var downloadPageLength = downloadPageButton.find("ul li").length;
	var downloadPageViewLimit = parseInt((downloadPageLength-1)/downloadPageView);
	var pageIndex = null;
	
	/* PJTWAUS-1 : 20200203 add */
	downloadPageButton.find('button').first().attr('aria-disabled', 'true');
	downloadPageButton.find('button').last().attr('aria-disabled', 'false');
	/*// PJTWAUS-1 : 20200203 add */

	downloadPageButton.find('li').on('click',function(){
		pageIndex = $(this).index()+1;
		$(downloadForm).find('input[name=page]').val(pageIndex);
		var url = $(downloadForm).attr('action');
		var mix = $(downloadForm).serialize();
		// var data = ajax.call(url, mix, 'html');
		ajax.call(url, mix, 'html', function(data){
			$(downloadList).find('.download-list li').remove();
			$(downloadList).find('.download-list').append(data);
			
			/* PJTWAUS-1 : 20200203 modify */
			downloadPageButton.find('li button').removeClass('active').removeAttr('aria-selected');
			downloadPageButton.find('li').eq(pageIndex-1).find('button').addClass('active').attr('aria-selected', 'true');
			
			var prevArrow = downloadPageButton.find('button[class="prev"]');
			var nextArrow = downloadPageButton.find('button[class="next"]');

			if (prevArrow !== undefined && nextArrow !== undefined && prevArrow.length > 0 && nextArrow.length > 0) {
				if (pageIndex == downloadPageLength) {
					downloadPageButton.find('button[class="next"]').attr('aria-disabled', true);
				} else {
					downloadPageButton.find('button[class="next"]').attr('aria-disabled', false);
				}
				
				if (pageIndex == 1) {
					downloadPageButton.find('button[class="prev"]').attr('aria-disabled', true);
				} else {
					downloadPageButton.find('button[class="prev"]').attr('aria-disabled', false);
				}
			}
			/*// PJTWAUS-1 : 20200203 modify */
			
			downloadResultNow.text(pageIndex);
		});
		return false;
	});
	
	function pageButton(){
		downloadPageButton.find('>button').on('click',function(){
			if($(this).hasClass('prev')){
				if (downloadPageViewIndex <= 0)
				{
					return;
				} else {
					downloadPageViewIndex--;
				}
			} else {
				if (downloadPageViewLimit <= downloadPageViewIndex)
				{
					return;
				} else {
					downloadPageViewIndex++;
				}
			}
			replacePage(downloadPageViewIndex);
			
			return false;
		});
	}

	function replacePage(downloadPageViewIndex){
		downloadPageButton.find('li').hide();
		for (var i=(downloadPageView*downloadPageViewIndex); i<((downloadPageView*downloadPageViewIndex)+downloadPageView) ; i++ )
		{
			downloadPageButton.find('li').eq(i).show();
		}
	}
	replacePage(0);
	pageButton();

	// adobe
	if($('.support-downloads').length>0 && $('.download-list').length>0) {
		// for Solutions > Download
		$('.download-list').on('click.adobe', 'li .links a.link-text', function() {
			var fileName = changeTitleFormat($(this).text()) + ':' + changeTitleFormat($(this).closest('.links').parent().find('.name').text());
			adobeTrackEvent('cs-solutions-download', {download_file_type : changeTitleFormat($(this).text()), download_file_name: fileName, page_event : {cs_file_download : true}});
		});
	}
});